import prodImage from "../../../assets/images/prod-image.png";

export interface ProductionHouseData {
  productionHouse: {
    title: string;
    heading: string;
    headingSuffix: string;
    description: string;
    highlightedText: string;
    features: string[];
    summary: string;
    button: {
      text: string;
      route: string;
    };
    images: {
      stadium: string;
    };
    overlays: {
      top: string;
      bottom: string;
    };
    banner: {
      text: string;
    };
  };
}

export const ProductionHouseConstants: ProductionHouseData = {
  productionHouse: {
    title: "CricCenter Production House",
    heading: "Your Match. The World Watching.",
    headingSuffix: " Lights. Camera. Cricket.",
    description:
      "We don't just stream matches. We produce cricket the way fans\nexpect to see it.\nOur 4K production cameras capture every ball in crystal-clear\nquality, streamed live and directly connected to the CricCenter\napp. That means smooth playback, sharp visuals, and broadcast-\nstyle graphics that feel like international matches, not local\nrecordings. With a professional production crew, multi-angle\ncamera setup, and live commentary, every match gets the\nattention it deserves — from club games to top-level tournaments.\nNo shaky feeds. No basic overlays. Just clean, premium coverage.\nAnd the best part?",
    highlightedText:
      "You don't just get a stream — you get your own branded app, powered by CricCenter.",
    features: [],
    summary:
      "One complete package: production, streaming, graphics, commentary, and technology — all under your control.",
    button: {
      text: "View More",
      route: "/",
    },
    images: {
      stadium: prodImage,
    },
    overlays: {
      top: "This is how modern cricket should look, feel, and be experienced.",
      bottom:
        "Our Cameras Our Crew Our Production House, and you enjoy hassle free power packed streaming.",
    },
    banner: {
      text: "CricCenter Production House",
    },
  },
};
